import React, { useState, useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { cachedGet } from '../utils/apiCache';

const ExamByTopic = () => {
  const { oppositionName } = useParams();
  const navigate = useNavigate();
  const [topics, setTopics] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    // Misma clave de caché que OpenQuestionsByTopic.js: si el usuario ya
    // visitó una de las dos pantallas, la otra no vuelve a pedir la lista.
    cachedGet(`topics:${oppositionName}`, () => axios.get(`/api/topics/${oppositionName}`))
      .then((response) => { if (!cancelled) setTopics(response.data); })
      .catch((error) => console.error('Error fetching topics', error))
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [oppositionName]);

  if (loading) return <div className="page-loader">Cargando temas…</div>;

  return (
    <div>
      <button
        onClick={() => navigate(`/oposicion/${oppositionName}`)}
        className="back-link"
      >
        ← Volver
      </button>

      <header className="page-header">
        <h1 className="page-title">Examen por tema</h1>
        <p className="page-subtitle">
          {oppositionName} · Selecciona un tema para practicar
        </p>
      </header>

      {topics.length === 0 ? (
        <div className="empty-state">
          <p>No hay temas con preguntas disponibles.</p>
        </div>
      ) : (
        <div className="list-grid">
          {topics.map((topic, index) => (
            <Link
              key={index}
              to={`/exam/topic/${encodeURIComponent(topic)}`}
              className="list-item"
            >
              <span className="list-item-title">{topic}</span>
              <span className="list-item-arrow">→</span>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default ExamByTopic;
